import React from 'react'

import ReactApexChart from 'react-apexcharts'

const Chart = () => {
    const series = [{
        name: 'Male',
        data: [0, 0, 0, 0, 0,0,0,0,0,0,0,0]
    }]

    const options = {

        chart: {
            type: 'bar',
            height: 350,
            toolbar: {
                show: false
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '80%',
                endingShape: 'rounded',
                borderRadius: 2,
                // borderRadiusApplication: 'end',

            },


        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 0,
            colors: ['transparent']
        },
        xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        },
        yaxis: {
            show: false
        },
        fill: {
            opacity: 1
        },

        colors: ['#57F2A8', '#8E75FF']

    }


    return <ReactApexChart options={options} series={series} type="bar" height={350} width={'100%'} />

}

export default Chart